const styles = {
  wrapper: 'relative leading-[0]',
  placeholder: 'absolute filter-blur inset-0 z-10',
};

export default styles;
